import { render, staticRenderFns } from "./Carousel.vue?vue&type=template&id=6195e8d5&scoped=true"
import script from "./Carousel.vue?vue&type=script&lang=ts"
export * from "./Carousel.vue?vue&type=script&lang=ts"
import style0 from "./Carousel.vue?vue&type=style&index=0&id=6195e8d5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6195e8d5",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCarousel } from 'vuetify/lib/components/VCarousel';
import { VCarouselItem } from 'vuetify/lib/components/VCarousel';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VBtn,VCarousel,VCarouselItem,VIcon,VImg,VRow,VSheet})
